import Routes from './Routes'
import { ThemeProvider } from '@material-ui/core'
import Theme from './theme/theme'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { QueryClient, QueryClientProvider } from 'react-query'

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      // refetchOnWindowFocus: false,
      // retry: true,
      // cacheTime: 1000 * 60 * 60, //default cache time 1 hour,
    },
  })
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={Theme}>
        <ToastContainer pauseOnFocusLoss={false} pauseOnHover={false} />
        <div style={{ backgroundColor: 'white' }}>
          <Routes />
        </div>
      </ThemeProvider>
    </QueryClientProvider>
  )
}

export default App
